var render = function () {
  var _vm$currentRound$puzz, _vm$currentRound;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'face-flip full-height'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('section', {
    style: {
      height: '100%',
      width: _vm.isMobile ? 'calc(100% - 77px)' : '100%'
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "cards-container"
  }, _vm._l((_vm$currentRound$puzz = (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.puzzlePieceCards) !== null && _vm$currentRound$puzz !== void 0 ? _vm$currentRound$puzz : [], function (card, index) {
    var _vm$currentRound2, _vm$currentRound2$puz;
    return _c('button', {
      key: ("card-" + index),
      class: ("figure-placeholder figure-type-" + ((_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$puz = _vm$currentRound2.puzzlePieceCards) === null || _vm$currentRound2$puz === void 0 ? void 0 : _vm$currentRound2$puz.length)),
      attrs: {
        "aria-label": ("Droppable area for " + (card.label)),
        "aria-pressed": false,
        "data-placeholder-name": card.label,
        "id": ("drop-" + index),
        "tabindex": "-1"
      },
      on: {
        "blur": _vm.handleOnPuzzleBlur,
        "focus": _vm.handleOnPuzzleFocus,
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnPuzzlePlaceholderEnterEvent($event);
        }
      }
    }, [_c('svg', {
      attrs: {
        "aria-labelledby": ((card.label) + "_label"),
        "width": "98%",
        "height": "100%"
      }
    }, [_c('image', {
      attrs: {
        "xlink:href": card.letterCard.image.src,
        "width": "100%",
        "height": "100%"
      }
    }), _c('image', {
      staticClass: "mainImg",
      attrs: {
        "xlink:href": card.answerImage.image.src,
        "width": "100%",
        "height": "100%",
        "y": "28%"
      }
    }), !_vm.isMatched[("m" + index)] ? _c('image', {
      attrs: {
        "xlink:href": card.puzzlePiece.missing.image.src,
        "width": ((card.puzzlePiece.width) + "%"),
        "height": "100%",
        "x": ((card.puzzlePiece.x) + "%"),
        "y": ((card.puzzlePiece.y) + "%")
      }
    }) : _vm._e()]), _vm.caption[("c" + index)] ? _c('figcaption', {
      attrs: {
        "id": ((card.label) + "_label")
      }
    }, [_c('b', {
      domProps: {
        "textContent": _vm._s(card.label)
      }
    })]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "puzzles-container"
  }, _vm._l(_vm.shuffledSteps, function (card) {
    return _c('button', {
      key: ("puzzle-" + (card.defaultIndex)),
      class: ("figure-card figure-type-" + (_vm.shuffledSteps.length) + " pure-button"),
      attrs: {
        "aria-label": ("Puzzle piece for " + (card.label)),
        "aria-pressed": false,
        "data-puzzle-name": card.label,
        "id": ("drag-" + (card.defaultIndex)),
        "tabindex": 0
      },
      on: {
        "blur": _vm.handleOnPuzzleBlur,
        "focus": _vm.handleOnPuzzleFocus,
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnPuzzleEnterEvent($event);
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "98%",
        "height": "100%"
      }
    }, [_c('mask', {
      style: _vm.maskStyle[card.defaultIndex],
      attrs: {
        "id": ("mask-" + (card.defaultIndex))
      }
    }, [_c('image', {
      attrs: {
        "xlink:href": card.puzzlePiece.full.image.src,
        "width": ((card.puzzlePiece.width + 11) + "%"),
        "height": "100%",
        "x": ((card.puzzlePiece.x - 6.5) + "%"),
        "y": ((card.puzzlePiece.y) + "%")
      }
    })]), _c('image', {
      attrs: {
        "xlink:href": card.puzzlePiece.full.image.src,
        "width": ((card.puzzlePiece.width + 11) + "%"),
        "height": "100%",
        "x": ((card.puzzlePiece.x - 6.5) + "%"),
        "y": ((card.puzzlePiece.y) + "%")
      }
    }), _c('svg', {
      style: _vm.svgStyle[card.defaultIndex],
      attrs: {
        "width": "100%",
        "mask": ("url(#mask-" + (card.defaultIndex) + ")")
      }
    }, [_c('image', {
      attrs: {
        "xlink:href": card.letterCard.image.src,
        "width": "100%",
        "height": "100%"
      }
    }), _c('image', {
      attrs: {
        "xlink:href": card.answerImage.image.src,
        "width": "100%",
        "height": "100%",
        "y": "28%"
      }
    })])])]);
  }), 0)])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }